import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  makeStyles,
  Paper,
  Chip,
  Typography,
  Grid,
  Divider,
  ButtonBase,
  Button,
} from '@material-ui/core';
import {
  getFacultyCourseAssociation,
  getFacultyBookingsData,
} from '../../../../Utils/apiServices';
import { KEY_STATUS } from '../../../../Utils/constants';
import KenLoader from '../../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
  box1: {
    // maxWidth: 832,
    // minWidth: 400,
    position: 'relative',
  },
  healthGrid: {
    marginTop: theme.spacing(2),
  },
  grid: {
    minWidth: '13.8vw',
  },
  detailTitle1: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textTransform: 'uppercase',
  },
  back: {
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
    marginLeft: '-8px',
  },
  iconBack: {
    height: 12,
  },
  loader: {
    minHeight: '100vh',
    minWidth: '100vh',
  },
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  boxContainer: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
    paddingTop: '62px',
    paddingBottom: '30px',
  },
  boxContainer1: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  imageSection: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '26px',
  },
  innerTitle: {
    fontSize: 16,
    marginTop: '30px',
  },
  subHeaderTitle: {
    width: '100%',
  },
}));

const FacultyPreferenceCourses = ({ contactId }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState(KEY_STATUS.success);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  useEffect(() => {
    const getFacultyData = async () => {
      const newData = await getFacultyBookingsData({ facultyId: contactId });
      if (newData?.message != "No Data Found" && Object.values(newData).length > 0) {
        let keys = Object.values(newData);
        let querry = `courseId=${keys[0]?.subjectId}&facultyId=${keys[0]?.facultyId}`;
        getFacultyCourseAssociation(querry)
          .then((res) => {
            console.log('Response', res);
            setData(res?.data);
          })
          .catch((err) => {
            console.log('Error', err);
          });
      }
    };
    getFacultyData();
  });
  // useEffect(() => {
  //   console.log('facultyData', facultyData);

  // }, []);

  return (
    <>
      {loading && <KenLoader />}
      {data?.length > 0 ? (
        data?.map((item) => {
          return (
            <Chip style={{ marginBottom: 3 }} label={`${item?.courseName}`} />
          );
        })
      ) : (
        <Grid xs={12}>
          <p style={{ textAlign: 'center' }}>No Data</p>
        </Grid>
      )}
    </>
  );
};
export default FacultyPreferenceCourses;
